/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, GetYoutubeIntegrationBroadcastsBroadcastsPathParams, GetYoutubeIntegrationBroadcastsBroadcastsQueryParams } from "../models/GetYoutubeIntegrationBroadcastsBroadcasts";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getYoutubeIntegrationBroadcastsBroadcasts } from "../axios/getYoutubeIntegrationBroadcastsBroadcasts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getYoutubeIntegrationBroadcastsBroadcastsQueryKey = (station: GetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: GetYoutubeIntegrationBroadcastsBroadcastsQueryParams) => ["web-app-bff-api", { url: '/youtube-broadcasts/:station', params: {station:station} }, ...(params ? [params] : [])] as const

export type GetYoutubeIntegrationBroadcastsBroadcastsQueryKey = ReturnType<typeof getYoutubeIntegrationBroadcastsBroadcastsQueryKey>

export function getYoutubeIntegrationBroadcastsBroadcastsQueryOptions(station: GetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: GetYoutubeIntegrationBroadcastsBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getYoutubeIntegrationBroadcastsBroadcastsQueryKey(station, params)
        return queryOptions<GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<Error>, GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return getYoutubeIntegrationBroadcastsBroadcasts(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Computes on-air intervals from stream gaps in the requested window and enriches them with live/ended YouTube video metadata for the station channel.
 * @summary List on-air broadcasts for a station
 * {@link /youtube-broadcasts/:station}
 */
export function useGetYoutubeIntegrationBroadcastsBroadcasts<TData = GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, TQueryData = GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, TQueryKey extends QueryKey = GetYoutubeIntegrationBroadcastsBroadcastsQueryKey>(station: GetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: GetYoutubeIntegrationBroadcastsBroadcastsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getYoutubeIntegrationBroadcastsBroadcastsQueryKey(station, params)
         

         const query = useQuery({
          ...getYoutubeIntegrationBroadcastsBroadcastsQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}